module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.vesselNameFilter ||
        _vm.Filter.contractNoFilter ||
        _vm.Filter.containerTypeFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.vesselVoyageNoFilter ||
        _vm.Filter.contractIdFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.vesselNameFilter ||
    _vm.Filter.contractNoFilter ||
    _vm.Filter.containerTypeFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.vesselVoyageNoFilter ||
    _vm.Filter.contractIdFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getContList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getContList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Contract No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Contract NO Filter",
      "id": "contractNoFilter",
      "name": "contractNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.contractNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "contractNoFilter", $$v)
      },
      expression: "Filter.contractNoFilter"
    }
  })], 1)], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vessel Name Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vessel Name Filter",
      "id": "vesselNameFilter",
      "name": "vesselNameFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.vesselNameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vesselNameFilter", $$v)
      },
      expression: "Filter.vesselNameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vessel Voyage No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vessel Voyage No Filter",
      "id": "vesselVoyageNoFilter",
      "name": "vesselVoyageNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.vesselVoyageNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vesselVoyageNoFilter", $$v)
      },
      expression: "Filter.vesselVoyageNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "id": "containerTypeFilter",
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getContractDashList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getContList,
      "fields": _vm.contractFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(row0) {
        return [_c('div', {
          staticClass: "d-flex align-items-center gap-2"
        }, [_c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": row0.toggleDetails
          }
        }, [_c('md-icon', [_vm._v(_vm._s(row0.detailsShowing ? "expand_less" : "expand_more"))]), _vm._v("\n                    " + _vm._s(row0.detailsShowing ? "Hide " : "Show ") + " " + _vm._s(row0.item.ContractNo) + "\n\n                  ")], 1)], 1)]
      }
    }, {
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "containerTypes",
      fn: function(row0) {
        return [_c('span', [_vm._v("Container Type : " + _vm._s(row0.item.containerTypes))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.item.totalContainerCountNo))]), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "0.675rem",
            "margin-left": "5px",
            "color": "blue"
          }
        }, [_vm._v("\n                  " + _vm._s(row0.item.totalTeusCountNo))]), _c('br')]
      }
    }, {
      key: "BuyingRateTotalPerunit",
      fn: function(row0) {
        return [_vm._v("\n                $" + _vm._s(row0.item.BuyingRateTotalPerunit) + "\n              ")]
      }
    }, {
      key: "BuyingPremiumRateTotalPerunit",
      fn: function(row0) {
        return [_vm._v("\n                $" + _vm._s(row0.item.BuyingPremiumRateTotalPerunit) + "\n              ")]
      }
    }, {
      key: "totalSellRate",
      fn: function(row0) {
        return [_vm._v("\n                $" + _vm._s(row0.item.totalSellRate) + "\n              ")]
      }
    }, {
      key: "totalTeusCountNo",
      fn: function(row0) {
        return [_c('span', {
          staticStyle: {
            "color": "blue"
          },
          on: {
            "click": function($event) {
              _vm.getTesuWiseData(row0.item)
            }
          }
        }, [_vm._v(_vm._s(row0.item.totalTeusCountNo))]), _c('br')]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [_c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "12"
          }
        }, [_c('b', [_vm._v("Teus Wise:")]), _vm._v(" " + _vm._s(row4.item.totalTeusComma))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Contract ID:")]), _vm._v(" " + _vm._s(row4.item.ContractId))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Contract No:")]), _vm._v(" " + _vm._s(row4.item.ContractNo))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Vessel Name:")]), _vm._v(" " + _vm._s(row4.item.VesselName))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Vessel Voyage No:")]), _vm._v(" " + _vm._s(row4.item.VesselVoyageNo))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("From:")]), _vm._v(" " + _vm._s(row4.item.From))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("To:")]), _vm._v(" " + _vm._s(row4.item.To))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Buying Rate:")]), _vm._v(" $" + _vm._s(row4.item.BuyingRate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Premium Buying Rate:")]), _vm._v(" $" + _vm._s(row4.item.BuyingPremiumRate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Selling Rate:")]), _vm._v(" $" + _vm._s(row4.item.SellingRate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Booking Nos:")]), _vm._v(" " + _vm._s(row4.item.bookingNo))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Validity Start Date:")]), _vm._v(" " + _vm._s(row4.item.ValidityStartDate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Validity End Date:")]), _vm._v(" " + _vm._s(row4.item.ValidityEndDate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Start Date:")]), _vm._v(" " + _vm._s(row4.item.startDate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("End Date:")]), _vm._v(" " + _vm._s(row4.item.endDate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Contract Create By:")]), _vm._v(" " + _vm._s(row4.item.ContractCreateBy))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Contract Create Date:")]), _vm._v(" " + _vm._s(row4.item.ContractCreateDate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Create By:")]), _vm._v(" " + _vm._s(row4.item.CreateBy))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Create Date:")]), _vm._v(" " + _vm._s(row4.item.CreateDate))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Buying Rate Total Per unit:")]), _vm._v(" $" + _vm._s(row4.item.BuyingRateTotalPerunit))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Buying Premium Rate Total Per unit:")]), _vm._v(" $" + _vm._s(row4.item.BuyingPremiumRateTotalPerunit))]), _vm._v(" "), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('b', [_vm._v("Selling Rate Total Per unit:")]), _vm._v(" $" + _vm._s(row4.item.totalSellRate))])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-Add-Open",
    staticClass: "w-90",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Container Wise Details'
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getTuesItem,
      "fields": _vm.tuesItemFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1))])]
      }
    }, {
      key: "BuyingRate",
      fn: function(row0) {
        return [_vm._v("\n            $" + _vm._s(row0.item.BuyingRate) + "\n          ")]
      }
    }, {
      key: "BuyingPremiumRate",
      fn: function(row0) {
        return [_vm._v("\n            $" + _vm._s(row0.item.BuyingPremiumRate) + "\n          ")]
      }
    }, {
      key: "SellingRate",
      fn: function(row0) {
        return [_vm._v("\n            $" + _vm._s(row0.item.SellingRate) + "\n          ")]
      }
    }, {
      key: "BuyingRateTotalPerunit",
      fn: function(row0) {
        return [_vm._v("\n            $" + _vm._s(row0.item.BuyingRateTotalPerunit) + "\n          ")]
      }
    }, {
      key: "BuyingPremiumRateTotalPerunit",
      fn: function(row0) {
        return [_vm._v("\n            $" + _vm._s(row0.item.BuyingPremiumRateTotalPerunit) + "\n          ")]
      }
    }, {
      key: "totalSellRate",
      fn: function(row0) {
        return [_vm._v("\n            $" + _vm._s(row0.item.totalSellRate) + "\n          ")]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c04956","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/consoleBooking/vesselWiseContractDashboard.vue
// module id = 2573
// module chunks = 0